import { render, staticRenderFns } from "./NoticeManage.vue?vue&type=template&id=8a3b7166&scoped=true&"
import script from "./NoticeManage.vue?vue&type=script&lang=js&"
export * from "./NoticeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3b7166",
  null
  
)

component.options.__file = "NoticeManage.vue"
export default component.exports